import { render, staticRenderFns } from "./RewardsSummary.vue?vue&type=template&id=2f2c98e1&"
import script from "./RewardsSummary.vue?vue&type=script&lang=js&"
export * from "./RewardsSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports